/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/StepCounter.css'

export default class StepCounter extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    render() {

        let indicators: any[] = []

        for (var i = 0; i < 6; i++) {
            indicators.push(
                <div
                    key={i}
                    className={`indicator
                    ${(this.props.stepIndex === i) ? ' active' : ''}
                    ${(this.props.stepIndex > i) ? ' success' : ''}`}
                >
                    <div className="step" />
                </div>)
        }

        return (
            <div className="stepCounter">
                <div className="stepCounter__text">
                    Step {(this.props.stepIndex <= 5) ? this.props.stepIndex + 1 : 6} of 6</div>
                <div className="stepCounter__indicators">
                    {indicators}
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/StepCounter/StepCounter.tsx